import styles from "./TypographyWireframes.styles.scss";

export const BodyWireframe = ({size = 'body1', width = 200, style}) => <div className={styles[size]} style={{width, ...style}} />;
export const SubtitleWireframe = ({size = 'subtitle1', width = 200, style}) => <div className={styles[size]} style={{width, ...style}} />;



// WEBPACK FOOTER //
// ./components/TypographyWireframes/TypographyWireframes.js